const alignCenter = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M0 2h16v1.5H0zm2 3.52h12v1.5H2zm0 7.04h12v1.5H2zM0 9.04h16v1.5H0z"/></svg>',
};

export { alignCenter as default };
